/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable max-len */
import React, { cloneElement, Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import SharedScript, {
  Maxymiser, Adobe, Ensighten, Qualtrics,
} from '@americanexpress/shared-scripts';
import {
  formUrlWithParams, convertLocaleToUpperCase,
} from '@americanexpress/one-maps-base';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { connect } from 'react-redux';
import { connectAsync } from 'iguazu';
import metadata from '../metadata';
import childRoutes from '../childRoutes';
import config from '../../config.json';
import { bgcId } from '../utils/bgcCodes';
import AnalyticsWrapper from './AnalyticsWrapper';
import OfflineWarning from './OfflineWarning/OfflineWarning';
import ErrorReporter from './ErrorReporter';
import reducer from '../duck';
import loadModuleData from '../config/loadModuleData';
import { mapStateToProps } from '../config/mapStateToProps';
import mapDispatchToProps from '../config/mapDispatchToProps';
import { loadDataAsProps } from '../config/loadDataAsProps';
import {
  ENABLE_ONEDATA_IB,
  ENABLE_ONEDATA_TYPEAHEAD,
  ENABLE_ONEDATA_READ_OFFERS,
  ENABLE_ONEDATA_ENROLL_OFFER,
  ENABLE_ONEDATA_READ_MERCHANTS,
  ENABLE_ONEDATA_IMPRESSIONS,
  ENABLE_ONEDATA_FEEDBACK,
} from '../config/enableOnedata';
import parseMerchantData from '../utils/parseMerchantData';
import normalizePathname from '../utils/normalizePathname';

let waited = 0;
let timeoutHolder;
class MapsRoot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadJs: true,
      shouldRender: false,
    };
  }

  // eslint-disable-next-line complexity
  componentDidMount() {
    this.waitForGoogleToLoad(30);
    this.setState({ // eslint-disable-line no-unused-vars
      loadJs: false,
    });
    setTimeout(() => {
      this.setState({ shouldRender: true });
    }, 1000);
    const {
      campaignSelected,
      locationDetails,
      searchCriteria,
    } = this.props.moduleState.baseReducers;
    this.updateLocale(this.props.location);
    if (campaignSelected.rewriteUrl) {
      let pathname = '';
      if (campaignSelected.isOnline) {
        pathname = `/${campaignSelected.locale}/maps/online`;
      } else if (campaignSelected.isOffers) {
        pathname = `/${campaignSelected.locale}/maps/offers`;
      } else {
        pathname = `/${campaignSelected.locale}/maps`;
      }

      this.props.router.push(`${pathname}${formUrlWithParams(locationDetails, searchCriteria, campaignSelected.version)}`);
      this.props.updateLocale(campaignSelected.locale);
    } else {
      const locale = convertLocaleToUpperCase(this.props.params.locale);
      this.props.updateLocale(locale);
      const { pathname } = this.props.location;
      const enableOfferLocales = ['en-US', 'en-AU', 'en-GB'];
      if (pathname === `/${this.props.params.locale}/maps/offers`) {
        if (!(enableOfferLocales && enableOfferLocales.includes(locale))) {
          this.props.router.push(`/${locale.toLowerCase()}/maps${formUrlWithParams(locationDetails, searchCriteria, campaignSelected.version)}`);
        }
      }
    }

    if (this.props.location.search && this.props.location.search.includes('ONLIND')
      && this.props.location.search.includes('near=') && this.props.location.search.includes('cl=')) {
      const search = this.props.location.search.split('&').filter((param) => !param.includes('cl=')).join('&');
      this.props.router.push(`${this.props.location.pathname}${search}`);
    }
  }

  getTitle = () => {
    if (this.props.location.pathname) {
      const path = this.props.location.pathname.toLowerCase().split('/');
      if (path[3] && (path[3] === 'offers' || path[3] === 'online')) {
        return metadata[`${path[3]}Title`][path[1]];
      }
      return metadata.mapsTitle[path[1]];
    }
    return false;
  };

  getMetaDescription = () => {
    if (this.props.location.pathname) {
      const path = this.props.location.pathname.toLowerCase().split('/');
      if (path[3] && (path[3] === 'offers' || path[3] === 'online')) {
        return metadata[`${path[3]}Description`][path[1]];
      }
      return metadata.mapsDescription[path[1]];
    }
    return false;
  };

  waitForGoogleToLoad = (interval, timeout = 5) => {
    timeoutHolder = setTimeout(() => {
      waited += interval;
      if (waited < timeout * 1000) {
        this.waitForGoogleToLoad(30);
      } else {
        clearTimeout(timeoutHolder);
      }
    }, interval);
  };

  updateLocale(location) {
    if (!location.pathname) return;
    const canonicalPathname = normalizePathname(location.pathname);
    if (canonicalPathname !== location.pathname) {
      this.props.router.push({
        pathname: canonicalPathname,
        search: location.search,
      });
    }
  }

  // eslint-disable-next-line complexity
  render() {
    const locale = convertLocaleToUpperCase(this.props.params.locale);
    const memberLocale = this.props.locale;
    const {
      addError,
      children,
      blueboxpublic,
      langPack,
      Login,
      AccountSwitcher,
      Footer,
      loadProducts,
      loadOffersMaps,
      resetMerchant,
      endSession,
      postLogout,
      updateLocale,
      gemUrl,
      enrolledOffersListLocal,
      merchantsFeedbackList,
      matchingKeywordsIguazu,
      typeaheadResults,
      merchantOfferDetailsIguazu,
      axpDomain,
      merchantsIguazu,
      merchantsOneData,
      ibDataIguazu,
      ibDataOneData,
      offersListIguazu,
      readOffersResults,
      enrolledOffersListIguazu,
      readEnrolledOffersResults,
      readMapsOfferResults,
      selectedProduct,
      productsList,
      loadIndustryBonus,
      loadLocation,
      updateOfferEnrollment,
      createMerchantMapOffersEnrollment,
      updateMerchantSuggestion,
      createMerchantEditSuggestion,
      // readMerchants,
      readKeywords,
      readMerchantPersonalizationTypeahead,
      // readOffersMaps,
      createActionCaptureBDaaS,
      createMerchantMapLogImpression,
      readProgramDetails,
      readFilterlabels,
      readInterstitial,
      readNotification,
      programDetailsIguazu,
      filterLabelIguazu,
      interstitialIguazu,
      notificationIguazu,
      isAuthenticated,
    } = this.props;
    const {
      locationDetails,
      searchCriteria,
      offerEnrolled,
      offersFailure,
      error,
      isLoginLoading,
      isLoginLoaded,
      isCopyLoaded,
      updateMerchantDetails,
      businessClosed,
      matchingKeywords,
      campaignSelected,
      campaignDetails,
      locationStatus,
      isLocationLoaded,
    } = this.props.moduleState.baseReducers;

    const isProgramDetailsLoaded = (typeof programDetailsIguazu !== 'undefined') && programDetailsIguazu.default;
    const programDetailsCopy = programDetailsIguazu
    && programDetailsIguazu.default ? programDetailsIguazu : {};
    const filterlabelCopy = filterLabelIguazu
    && filterLabelIguazu.default ? filterLabelIguazu : {};
    const interstitialCopy = interstitialIguazu
    && interstitialIguazu.default ? interstitialIguazu : {};
    const notificationCopy = notificationIguazu
    && notificationIguazu.default ? notificationIguazu : {};

    /* istanbul ignore next */
    const merchantResultsOneData = merchantsOneData && merchantsOneData.merchants
    && merchantsOneData.merchants[0]
    && merchantsOneData.merchants[0].component_merchants
      && merchantsOneData.merchants[0].component_merchants[0]
      && merchantsOneData.merchants[0].component_merchants[0].merchant_metadata
      ? merchantsOneData.merchants[0].component_merchants[0].merchant_metadata : [];

    let newMerRes = [];
    /* istanbul ignore next */
    if (ENABLE_ONEDATA_READ_MERCHANTS) {
      newMerRes = merchantResultsOneData.map((mer) => parseMerchantData(mer));
    }
    /* istanbul ignore next */
    const merchantResultsIguazu = merchantsIguazu && merchantsIguazu.merchants ? merchantsIguazu.merchants : [];
    /* istanbul ignore next */
    const merchants = ENABLE_ONEDATA_READ_MERCHANTS ? newMerRes : merchantResultsIguazu;
    /* istanbul ignore next */
    const readMerchants = selectedProduct ? this.props.readMerchantsOneData : this.props.readMerchantsPublicOneData;

    /* istanbul ignore next */
    const merchantOffersList = ENABLE_ONEDATA_READ_OFFERS ? readMapsOfferResults : merchantOfferDetailsIguazu;
    /* istanbul ignore next */
    const offersResults = ENABLE_ONEDATA_READ_OFFERS ? readOffersResults : offersListIguazu;
    /* istanbul ignore next */
    const enrolledOffersResults = ENABLE_ONEDATA_READ_OFFERS ? readEnrolledOffersResults : enrolledOffersListIguazu;

    /* istanbul ignore next */
    const offersList = offersResults && offersResults.treatments
      && (offersResults.treatments.length > 0
        ? offersResults.treatments[0].component_treatments[0].treatment_metadata
        : offersResults.treatments);
    /* istanbul ignore next */
    const enrolledOffersList = enrolledOffersResults && enrolledOffersResults.treatments
      && (enrolledOffersResults.treatments.length > 0
        ? enrolledOffersResults.treatments[0].component_treatments[0].treatment_metadata
        : enrolledOffersResults.treatments);

    /* istanbul ignore next */
    const readOffersMaps = ENABLE_ONEDATA_READ_OFFERS ? this.props.readOffersMapsOneData : this.props.readOffersMapsBDaaS;
    /* istanbul ignore next */
    const readOffers = ENABLE_ONEDATA_READ_OFFERS ? this.props.readOffersOneData : this.props.readOffersBDaaS;
    /* istanbul ignore next */
    const readEnrolledOffers = ENABLE_ONEDATA_READ_OFFERS ? this.props.readEnrolledOffersOneData : this.props.readEnrolledOffersBDaaS;
    /* istanbul ignore next */
    const enrollOffer = ENABLE_ONEDATA_ENROLL_OFFER ? this.props.createMerchantMapOffersEnrollment : this.props.updateOfferEnrollment;
    /* istanbul ignore next */
    const updateMerchant = ENABLE_ONEDATA_FEEDBACK ? this.props.createMerchantEditSuggestion : this.props.updateMerchantSuggestion;

    const loadProgramDetails = this.props.readProgramDetails;
    const loadFilterlabels = this.props.readFilterlabels;
    const loadInterstitial = this.props.readInterstitial;
    const loadNotification = this.props.readNotification;

    const isLoading = this.props.isLoading();
    let isLoaded = isLocationLoaded;
    const { pathname } = this.props.location;
    if (pathname === `/${this.props.params.locale}/maps/online`) {
      /* istanbul ignore next */
      isLoaded = merchants && !isLoading;
    }
    if (pathname === `/${this.props.params.locale}/maps/offers`) {
      isLoaded = isLocationLoaded && !isLoading;
    }
    if (pathname === `/${this.props.params.locale}/maps`) {
      /* istanbul ignore next */
      isLoaded = isLocationLoaded && merchants && !isLoading;
    }

    let ibData;
    let isIbAvailable = false;
    let bgcLoaded = false;
    /* istanbul ignore next */
    const isIbLoaded = (typeof ibDataOneData !== 'undefined') && ibDataOneData
      && (typeof ibDataOneData.statusCode !== 'undefined') && ibDataOneData.statusCode.includes('SUCCESS');
    /* istanbul ignore next */
    if (ENABLE_ONEDATA_IB && isIbLoaded) {
      /* istanbul ignore next */
      ibData = ibDataOneData.industryBonuses
        ? ibDataOneData.industryBonuses.filter((i) => bgcId.indexOf(i.bgc_id) > -1)
        : [];
      bgcLoaded = ibDataOneData && ibDataOneData.industryBonuses;
      isIbAvailable = ibDataOneData && ibDataOneData.industryBonuses
        && ibDataOneData.industryBonuses.length > 0;
    } else if (!ENABLE_ONEDATA_IB && ibDataIguazu && ibDataIguazu.industry_bonuses) {
      /* istanbul ignore next */
      ibData = ibDataIguazu && ibDataIguazu.industry_bonuses
        ? ibDataIguazu.industry_bonuses.filter((i) => bgcId.indexOf(i.bgc_id) > -1)
        : [];
      /* istanbul ignore next */
      bgcLoaded = ibDataIguazu && ibDataIguazu.industry_bonuses;
      /* istanbul ignore next */
      isIbAvailable = ibDataIguazu && ibDataIguazu.industry_bonuses
      && ibDataIguazu.industry_bonuses.length > 0;
    }
    /* istanbul ignore next */
    const readIndustryBonus = ENABLE_ONEDATA_IB ? this.props.readIndustryBonusOneData : this.props.readIndustryBonusBDaaS;

    /* istanbul ignore next */
    const matchingTypeaheadResults = ENABLE_ONEDATA_TYPEAHEAD ? typeaheadResults : matchingKeywordsIguazu;
    /* istanbul ignore next */
    const readTypeahead = ENABLE_ONEDATA_TYPEAHEAD ? readMerchantPersonalizationTypeahead : readKeywords;
    /* istanbul ignore next */
    const createActionCapture = ENABLE_ONEDATA_IMPRESSIONS ? createMerchantMapLogImpression : createActionCaptureBDaaS;

    if (global.google && !campaignSelected.rewriteUrl) {
      clearTimeout(timeoutHolder);

      const { google } = global;
      const child = children ? cloneElement(children, {
        addError,
        blueboxpublic,
        language: langPack,
        Login,
        AccountSwitcher,
        Footer,
        locale,
        google,
        merchants,
        offersList,
        enrolledOffersList,
        merchantOffersList,
        error,
        locationDetails,
        searchCriteria,
        isLoaded,
        offerEnrolled,
        offersFailure,
        locationStatus,
        isLocationLoaded,
        isLoginLoading,
        isLoginLoaded,
        updateMerchantDetails,
        businessClosed,
        matchingKeywords,
        campaignSelected,
        campaignDetails,
        loadProducts,
        loadIndustryBonus,
        loadOffersMaps,
        loadProgramDetails,
        loadFilterlabels,
        loadInterstitial,
        loadLocation,
        loadNotification,
        enrollOffer,
        updateMerchant,
        resetMerchant,
        axpDomain,
        merchantsIguazu,
        selectedProduct,
        memberLocale,
        productsList,
        gemUrl,
        enrolledOffersListLocal,
        merchantsFeedbackList,
        matchingTypeaheadResults,
        endSession,
        postLogout,
        updateLocale,
        isCopyLoaded,
        programDetailsCopy,
        filterlabelCopy,
        interstitialCopy,
        notificationCopy,
        ibData,
        isIbAvailable,
        bgcLoaded,
        isProgramDetailsLoaded,
        updateOfferEnrollment,
        createMerchantMapOffersEnrollment,
        updateMerchantSuggestion,
        createMerchantEditSuggestion,
        readIndustryBonus,
        readMerchants,
        readOffers,
        readEnrolledOffers,
        readOffersMaps,
        readTypeahead,
        createActionCapture,
        readProgramDetails,
        readFilterlabels,
        readInterstitial,
        readNotification,
        isAuthenticated,
      }) : '';

      return (
        <ErrorReporter addErrorToReport={addError} publicGuid={blueboxpublic}>
          <SharedScript
            name="one-identity-session"
            version="^1.8.1"
            windowCheck="AmexSession"
          />
          <Helmet
            {...{
              titleTemplate: this.getTitle() ? '%s' : 'American Express - %s',
              title: this.getTitle(),
              meta: [{
                name: 'description',
                content: this.getMetaDescription() ? this.getMetaDescription() : '',
              }, {
                name: 'viewport',
                content: 'width=device-width, initial-scale=1',
              }],
              link: [{
                rel: 'stylesheet',
                href: 'https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.24.0/package/dist/6.24.0/styles/dls.min.css',
              }],
            }}
          >
            <html lang={locale} />
          </Helmet>
          { this.state.shouldRender && (
            <Qualtrics
              {...config.qualtrics}
            />
          ) }
          <Maxymiser version="^2.0.0" async={true} />
          <Adobe version="1.2.0" />
          <Ensighten version="^1.0.0" />
          <OfflineWarning />
          <AnalyticsWrapper>
            {child}
          </AnalyticsWrapper>
        </ErrorReporter>
      );
    }

    if (this.state.loadJs) {
      return (
        <ErrorReporter addErrorToReport={addError} publicGuid={blueboxpublic}>
          <SharedScript
            name="one-identity-session"
            version="^1.8.1"
            windowCheck="AmexSession"
          />
          <Helmet
            {...{
              titleTemplate: this.getTitle() ? '%s' : 'American Express - %s',
              title: this.getTitle(),
              meta: [{
                name: 'description',
                content: this.getMetaDescription() ? this.getMetaDescription() : '',
              }, {
                name: 'viewport',
                content: 'width=device-width, initial-scale=1',
              }],
              link: [{
                rel: 'stylesheet',
                href: 'https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.24.0/package/dist/6.24.0/styles/dls.min.css',
              }],
              script: [
                {
                  src: `https://maps.googleapis.com/maps/api/js?key=${process.env.AXP_GOOGLE_API_KEY}&client=gme-americanexpresstravel&language=${locale}&channel=AMEXMAPS_STATIC&libraries=places`,
                },
                {
                  src: 'https://www.google.com/recaptcha/api.js',
                  async: true,
                  defer: true,
                },
              ],
            }}

          />
          { this.state.shouldRender && (
            <Qualtrics
              {...config.qualtrics}
            />
          ) }
          <Maxymiser version="^2.0.0" async={true} />
          <Adobe version="1.2.0" />
          <Ensighten version="^1.0.0" />
          <OfflineWarning />
          <AnalyticsWrapper>
            {children}
          </AnalyticsWrapper>
        </ErrorReporter>
      );
    }
    return (
      <ErrorReporter addErrorToReport={addError} publicGuid={blueboxpublic}>
        <SharedScript
          name="one-identity-session"
          version="^1.8.1"
          windowCheck="AmexSession"
        />
        { this.state.shouldRender && (
          <Qualtrics
            {...config.qualtrics}
          />
        ) }
        <Maxymiser version="^2.0.0" async={true} />
        <Adobe version="1.2.0" />

        <Ensighten version="^1.0.0" />
        <OfflineWarning />
        <AnalyticsWrapper>
          {children}
        </AnalyticsWrapper>
      </ErrorReporter>
    );
  }
}
MapsRoot.childRoutes = childRoutes;

// Content Security Policy
/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line global-require
  MapsRoot.appConfig = require('../config/csp').default;
}

MapsRoot.propTypes = {
  addErrorToReport: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  Login: PropTypes.func.isRequired,
  AccountSwitcher: PropTypes.func.isRequired,
  Footer: PropTypes.func.isRequired,
  locale: PropTypes.string,
  langPack: PropTypes.shape(),
  addError: PropTypes.func.isRequired,
  blueboxpublic: PropTypes.string.isRequired,
  moduleState: PropTypes.shape({
    baseReducers: PropTypes.shape({
      campaignSelected: PropTypes.shape(),
      locationDetails: PropTypes.shape(),
      searchCriteria: PropTypes.shape(),
      merchants: PropTypes.arrayOf,
      offersList: PropTypes.arrayOf,
      enrolledOffersList: PropTypes.arrayOf,
      isLoading: PropTypes.bool,
      isLoaded: PropTypes.bool,
      offerEnrolled: PropTypes.string,
      updateMerchantDetails: PropTypes.string,
      businessClosed: PropTypes.string,
      matchingKeywords: PropTypes.arrayOf,
      campaignDetails: PropTypes.shape(),
      isLoginLoading: PropTypes.bool,
      isLoginLoaded: PropTypes.bool,
      isCopyLoaded: PropTypes.bool,
      offersFailure: PropTypes.bool,
      error: PropTypes.bool,
      programDetailsCopy: PropTypes.shape(),
      filterlabelCopy: PropTypes.shape(),
      interstitialCopy: PropTypes.shape(),
      notificationCopy: PropTypes.shape(),
      locationStatus: PropTypes.shape(),
      isLocationLoaded: PropTypes.string,
      isIbAvailable: PropTypes.bool,
      ibData: PropTypes.arrayOf,
      bgcLoaded: PropTypes.bool,
      isProgramDetailsLoaded: PropTypes.bool,
    }),
  }),
  router: PropTypes.shape({
    push: PropTypes.func,
  }),
  updateLocale: PropTypes.func,
  params: PropTypes.shape({
    locale: PropTypes.string,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
  loadProducts: PropTypes.func,
  loadMerchants: PropTypes.func,
  loadOffers: PropTypes.func,
  loadEnrolledOffers: PropTypes.func,
  enrollOffer: PropTypes.func,
  loadOffersMaps: PropTypes.func,
  updateMerchant: PropTypes.func,
  resetMerchant: PropTypes.func,
  closeMerchantBusiness: PropTypes.func,
  loadMatchingKeywords: PropTypes.func,
  captureActions: PropTypes.func,
  endSession: PropTypes.func,
  postLogout: PropTypes.func,
  gemUrl: PropTypes.string,
  axpDomain: PropTypes.string,
  selectedProduct: PropTypes.string,
  productsList: PropTypes.shape(),
  loadProgramDetails: PropTypes.func,
  loadFilterlabels: PropTypes.func,
  loadInterstitial: PropTypes.func,
  loadNotification: PropTypes.func,
  loadLocation: PropTypes.func,
  programDetailsCopy: PropTypes.shape(),
  filterlabelCopy: PropTypes.shape(),
  loadIndustryBonus: PropTypes.func,
  isLoading: PropTypes.func,
  enrolledOffersListLocal: PropTypes.shape(),
  localeFilename: PropTypes.string,
  merchantsIguazu: PropTypes.shape(),
  merchantsOneData: PropTypes.shape,
  ibDataIguazu: PropTypes.shape(),
  ibDataOneData: PropTypes.shape(),
  offersListIguazu: PropTypes.shape(),
  readOffersResults: PropTypes.shape,
  readMapsOfferResults: PropTypes.shape,
  enrolledOffersListIguazu: PropTypes.shape(),
  readEnrolledOffersResults: PropTypes.shape,
  updateOfferEnrollment: PropTypes.func,
  createMerchantEditSuggestion: PropTypes.func,
  createMerchantMapOffersEnrollment: PropTypes.func,
  updateMerchantSuggestion: PropTypes.func,
  readIndustryBonusBDaaS: PropTypes.func,
  readIndustryBonusOneData: PropTypes.func,
  readMerchantsBDaaS: PropTypes.func,
  readMerchantsOneData: PropTypes.func,
  readMerchantsPublicOneData: PropTypes.func,
  readKeywords: PropTypes.func,
  readMerchantPersonalizationTypeahead: PropTypes.func,
  readOffers: PropTypes.func,
  readOffersBDaaS: PropTypes.func,
  readOffersOneData: PropTypes.func,
  readEnrolledOffers: PropTypes.func,
  readEnrolledOffersBDaaS: PropTypes.func,
  readEnrolledOffersOneData: PropTypes.func,
  readOffersMapsBDaaS: PropTypes.func,
  readOffersMapsOneData: PropTypes.func,
  createActionCapture: PropTypes.func,
  createActionCaptureBDaaS: PropTypes.func,
  createMerchantMapLogImpression: PropTypes.func,
  merchantsFeedbackList: PropTypes.shape(),
  matchingKeywordsIguazu: PropTypes.shape(),
  typeaheadResults: PropTypes.shape,
  readProgramDetails: PropTypes.func,
  readFilterlabels: PropTypes.func,
  readInterstitial: PropTypes.func,
  readNotification: PropTypes.func,
  programDetailsIguazu: PropTypes.shape(),
  filterLabelIguazu: PropTypes.shape(),
  interstitialIguazu: PropTypes.shape(),
  notificationIguazu: PropTypes.shape(),
  isAuthenticated: PropTypes.bool,
  merchantOfferDetailsIguazu: PropTypes.shape(),
};

MapsRoot.defaultProps = {
  locale: 'en-US',
  location: {
    pathname: '',
    search: '',
  },
  langPack: {},
  moduleState: {},
  updateLocale: PropTypes.func,
  router: {},
  params: {},
  readProgramDetails: PropTypes.func,
  readFilterlabels: PropTypes.func,
  readInterstitial: PropTypes.func,
  readNotification: PropTypes.func,
  programDetailsIguazu: {
    default: {
    },
  },
  filterLabelIguazu: {
    default: {
    },
  },
  interstitialIguazu: {
    default: {
    },
  },
  notificationIguazu: {
    default: {
    },
  },
  loadProducts: PropTypes.func,
  loadMerchants: PropTypes.func,
  loadOffers: PropTypes.func,
  loadEnrolledOffers: PropTypes.func,
  enrollOffer: PropTypes.func,
  loadOffersMaps: PropTypes.func,
  updateMerchant: PropTypes.func,
  resetMerchant: PropTypes.func,
  closeMerchantBusiness: PropTypes.func,
  loadMatchingKeywords: PropTypes.func,
  captureActions: PropTypes.func,
  endSession: PropTypes.func,
  postLogout: PropTypes.func,
  gemUrl: '',
  axpDomain: '',
  selectedProduct: '',
  productsList: PropTypes.shape(),
  loadLocation: PropTypes.func,
  loadProgramDetails: PropTypes.func,
  loadFilterlabels: PropTypes.func,
  loadInterstitial: PropTypes.func,
  loadNotification: PropTypes.func,
  programDetailsCopy: {},
  filterlabelCopy: {},
  loadIndustryBonus: PropTypes.func,
  isLoading: PropTypes.func,
  enrolledOffersListLocal: PropTypes.shape(),
  localeFilename: PropTypes.string,
  merchantsIguazu: PropTypes.shape(),
  merchantsOneData: PropTypes.shape,
  ibDataIguazu: PropTypes.shape(),
  ibDataOneData: {
    industryBonuses: PropTypes.shape,
  },
  offersListIguazu: PropTypes.shape(),
  readOffersResults: PropTypes.shape,
  readMapsOfferResults: PropTypes.shape,
  enrolledOffersListIguazu: PropTypes.shape(),
  readEnrolledOffersResults: PropTypes.shape,
  updateOfferEnrollment: PropTypes.func,
  createMerchantMapOffersEnrollment: PropTypes.func,
  updateMerchantSuggestion: PropTypes.func,
  createMerchantEditSuggestion: PropTypes.func,
  readIndustryBonusBDaaS: PropTypes.func,
  readIndustryBonusOneData: PropTypes.func,
  readMerchantsBDaaS: PropTypes.func,
  readMerchantsOneData: PropTypes.func,
  readOffers: PropTypes.func,
  readOffersBDaaS: PropTypes.func,
  readOffersOneData: PropTypes.func,
  readEnrolledOffers: PropTypes.func,
  readEnrolledOffersBDaaS: PropTypes.func,
  readEnrolledOffersOneData: PropTypes.func,
  readOffersMapsBDaaS: PropTypes.func,
  readOffersMapsOneData: PropTypes.func,
  readKeywords: PropTypes.func,
  readMerchantPersonalizationTypeahead: PropTypes.func,
  createActionCapture: PropTypes.func,
  createActionCaptureBDaaS: PropTypes.func,
  createMerchantMapLogImpression: PropTypes.func,
  merchantsFeedbackList: PropTypes.shape(),
  matchingKeywordsIguazu: PropTypes.shape(),
  typeaheadResults: PropTypes.shape,
  isAuthenticated: PropTypes.bool,
  merchantOfferDetailsIguazu: PropTypes.shape(),
};

MapsRoot.holocron = {
  name: 'axp-maps-root',
  reducer,
  loadModuleData,
};

const hocChain = compose(
  oneAppModuleWrapper('axp-maps-root'),
  connect(mapStateToProps, mapDispatchToProps),
  connectAsync({ loadDataAsProps })
);

export default hocChain(MapsRoot);
